import { Box } from "@mui/material";
import { alpha } from "@mui/material/styles";
import { FS } from "@plannel/utils/font-util";

/*
 * 개수 요약 배지 — 라벨(회색) + 값(진하게)을 알약 하나에 담는다.
 *   <StatPill label={t("measure")} value={88} />           기본(회색)
 *   <StatPill label={t("custom")} value={6} accent />       강조(primary 톤 + 앞에 점)
 *
 * 카드 헤더에서 "무엇이 몇 개인지"를 제목보다 작게 알리는 용도.
 * Typography 를 쓰지 않는다 — 전역 SCSS(.content-main .MuiTypography-root)가 font-size 를 덮어써서
 * 설정 화면 안에서만 글자가 커지는 사고가 난다.
 *
 * component: 기본 div. <h2> 안(BaseConfigModal 의 titleAdornment) 처럼 div 를 넣으면 안 되는
 *            자리에서는 "span" 을 준다.
 */
const StatPill = ({ label, value, accent, component = "div", sx }) => (
  <Box
    component={component}
    sx={{
      display: "inline-flex", alignItems: "center", gap: 0.5,
      height: 22, px: 1, borderRadius: 999,
      bgcolor: theme => (accent ? alpha(theme.palette.primary.main, 0.1) : theme.palette.grey[100]),
      color: accent ? "primary.dark" : "text.secondary",
      fontSize: FS.BODY, lineHeight: 1, whiteSpace: "nowrap",
      ...sx,
    }}
  >
    {accent && (
      <Box sx={{ width: 5, height: 5, borderRadius: "50%", bgcolor: "primary.main", flexShrink: 0 }} />
    )}
    {label}
    <Box component="span" sx={{ fontWeight: 700, color: accent ? "primary.dark" : "text.primary" }}>{value}</Box>
  </Box>
);

export default StatPill;
